import { render, staticRenderFns } from "./FabricOrdersList.vue?vue&type=template&id=59600a60&scoped=true"
import script from "./FabricOrdersList.vue?vue&type=script&lang=js"
export * from "./FabricOrdersList.vue?vue&type=script&lang=js"
import style0 from "./FabricOrdersList.vue?vue&type=style&index=0&id=59600a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59600a60",
  null
  
)

export default component.exports